// Which backend this build talks to, and therefore whether it may report to
// Sentry at all.
//
// NODE_ENV cannot answer that: every CRA production build reports "production",
// including one built against the dev API. Events from those land in the same
// issue list as live ones and turn every users-affected count into a mix of
// real users and whoever was testing. REACT_APP_API_HOST knows the truth, and
// environments.json is what sets it per target.

const PRODUCTION_API_HOSTS = ["myusual-1-aus-prod.web.app", "api-vwooytmp2q-ts.a.run.app"];

export function resolveSentryEnvironment(apiHost) {
  let hostname;
  try {
    hostname = new URL(String(apiHost)).hostname;
  } catch {
    return "non-production";
  }
  return PRODUCTION_API_HOSTS.includes(hostname) ? "production" : "non-production";
}
